// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9ac55f50","617":"602e051b","847":"6f666f6d"}[chunkId] + ".chunk.js";
};